<script setup lang="ts">
import { computed } from 'vue';

import { i18n } from '@apps/main/modules/localization/localizationSetup';

import { AppMapToggleButton } from '@libs/ui';
import type { AppMapToggleContent } from '@libs/ui';

import { HotelSelectionViewType } from '../models';
import { useHotelSelectionStore } from '../stores';

const { t } = i18n.global;
const hotelSelectionStore = useHotelSelectionStore();

const listButton: AppMapToggleContent = {
  text: t('product_search_selector.list'),
  icon: 'list',
  action: hotelSelectionStore.toggleMap,
};
const mapButton: AppMapToggleContent = {
  text: t('product_search_selector.map'),
  icon: 'map',
  action: hotelSelectionStore.toggleMap,
};

const buttonContent = computed(() =>
  hotelSelectionStore.viewType === HotelSelectionViewType.List
    ? mapButton
    : listButton
);
</script>

<template>
  <AppMapToggleButton
    v-if="hotelSelectionStore.viewType === HotelSelectionViewType.List"
    :content="buttonContent"
  />
</template>
